import { useEffect, useMemo, useState } from "react";
import { honeyVestingContract } from "config";
import { useContractRead } from "wagmi";
import { BigNumber } from "ethers";

const useVestingAmountRemaining = (
  method: string,
  address?: string
): [
  remaining: BigNumber[] | undefined,
  remainingSum: BigNumber | undefined,
  readVestingAmountRemaining: () => void
] => {
  const [remaining, setRemaining] = useState<BigNumber[]>();
  const remainingSum = useMemo(
    () => remaining?.reduce((sum, val) => sum.add(val), BigNumber.from("0")),
    [remaining]
  );

  const [{ data: remainingData }, readVestingAmountRemaining] = useContractRead(
    {
      addressOrName: honeyVestingContract.address,
      contractInterface: honeyVestingContract.interface,
    },
    method,
    {
      args: address,
    }
  );

  useEffect(() => {
    if (remainingData !== undefined) {
      setRemaining(remainingData.map((remaining) => BigNumber.from(remaining)));
    }
  }, [remainingData]);

  return [remaining, remainingSum, readVestingAmountRemaining];
};

export default useVestingAmountRemaining;
